
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/math-vault/site-map",
      function () {
        return require("private-next-pages/math-vault/site-map.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/math-vault/site-map"])
      });
    }
  